import React, { useState, useEffect } from 'react'
import { useParams } from 'react-router-dom'
import axios from 'axios'
import Post from '../component/functions/Post'

export default function Ep() {
    const params = useParams()
    const [post, setPost] = useState([])
    const [loaded, setLoaded] = useState(false)

    useEffect(() => {
        let isMounted = true

        const theData = async () => {
            try {
                setLoaded(false)

                const res = await axios.get(
                    process.env.REACT_APP_WP + 'episodes?slug=' + params.postslug
                )

                if (isMounted) {
                    setPost(res.data)
                    setLoaded(true)
                }
            } catch (e) {
                console.log(e)
                if (isMounted) {
                    setLoaded(true)
                }
            }
        }

        theData()

        return () => {
            isMounted = false
        }
    }, [params.postslug])

    return (
        <div>
            {loaded ? (
                post.length > 0 ? (
                    post.map((thepost) => <Post key={thepost.id} post={thepost} />)
                ) : (
                    <h1>No episode found.</h1>
                )
            ) : (
                <h1>Loading...</h1>
            )}
        </div>
    )
}